var _g, _defs;
const _excluded = ["svgRef", "title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import React from "react";
const SvgEmptyFile = _ref => {
  let svgRef = _ref.svgRef,
    title = _ref.title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 102,
    height: 123,
    viewBox: "0 0 102 123",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("circle", {
    opacity: 0.18,
    cx: 50.9998,
    cy: 51.2703,
    r: 51.2703,
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 31.1571,
    y: 50.5203,
    width: 49.6289,
    height: 69.7068,
    rx: 7,
    transform: "rotate(2.5 31.1571 50.5203)",
    fill: "white",
    stroke: "#1A21BA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.728615,
    y: 45.7783,
    width: 53.6289,
    height: 73.7068,
    rx: 9,
    transform: "rotate(-7.5 0.728615 45.7783)",
    fill: "white",
    stroke: "#1A21BA",
    strokeWidth: 2
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.18,
    d: "M2.89528 54.5708C2.31858 50.1903 5.40215 46.1717 9.78263 45.595L45.1067 40.9445C49.4872 40.3678 53.5058 43.4514 54.0825 47.8319L55.191 56.2518L4.00379 62.9907L2.89528 54.5708Z",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 64.1699,
    y: 42.051,
    width: 2.1512,
    height: 7.17068,
    rx: 1.0756,
    transform: "rotate(82.5 64.1699 42.051)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 44.5249,
    y: 30.1722,
    width: 2.1512,
    height: 7.17068,
    rx: 1.0756,
    transform: "rotate(-7.5 44.5249 30.1722)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 57.1289,
    y: 32.1292,
    width: 2.1512,
    height: 7.17068,
    rx: 1.0756,
    transform: "rotate(37.5 57.1289 32.1292)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 9.35449,
    y: 65.1792,
    width: 41.5899,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 9.35449 65.1792)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 11.2266,
    y: 79.3979,
    width: 41.5899,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 11.2266 79.3979)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 13.0981,
    y: 93.6166,
    width: 41.5899,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 13.0981 93.6166)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 10.103,
    y: 70.8667,
    width: 15.0584,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 10.103 70.8667)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 11.9751,
    y: 85.0854,
    width: 15.0584,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 11.9751 85.0854)",
    fill: "#1A21BA"
  }), /*#__PURE__*/React.createElement("rect", {
    opacity: 0.18,
    x: 13.8472,
    y: 99.304,
    width: 15.0584,
    height: 2.86827,
    rx: 1.43414,
    transform: "rotate(-7.5 13.8472 99.304)",
    fill: "#1A21BA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 102,
    height: 123,
    fill: "white"
  })))));
};
const ForwardRef = /*#__PURE__*/React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(SvgEmptyFile, _extends({
  svgRef: ref
}, props)));
export default __webpack_public_path__ + "static/media/empty-file.1abffc73.svg";
export { ForwardRef as ReactComponent };